import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    BASE_URL,
} from "../../constants";
import axios from "axios";
import ShowErrorAlert from "../../components/ErrorAlert";
import { extractErrorMessage } from "../../utils";
import { useSelector } from "react-redux";
import DashboardLayout from "../../components/DashboardLayout";

import { useForm } from "react-hook-form";

import Record from "../RecordDetails/RecordDetails.Record";
import DashboardCard from "../../components/DashboardCard";
import DashboardTable from "../../components/DashboardTable";
import BlueText from "../../components/BlueText";
import { DUES_TABLE_DATA_KEYS, DUES_TABLE_HEADINGS } from "./Dues.constant";

const Dues = () => {
    // Redux Store
    const {
        auth: {
            user: { _id: userId, role },
            token,
        },
    } = useSelector((state) => state);
    const { recordId, updateRecordRequestId } = useParams();
    const navigate = useNavigate();

    const {
        handleSubmit,
        formState: { errors },
        control,
    } = useForm({
        values: {
            name: "",
            file: "",
        },
    });

    // State Variables
    const [record, setRecord] = useState(null);
    const [owner, setOwner] = useState(null);
    const [loading, setLoading] = useState(false);
    const [updateRecordRequest, setUpdateRecordRequest] = useState(null);
    const [survey, setSurvey] = useState(null);

    async function getRequestSurveyReq() {
        setLoading(true);
        try {
            const {
                data: { record: recordData, owner: ownerData },
            } = await axios.get(`${BASE_URL}/users/${userId}/records/${recordId}`, {
                headers: {
                    Authorization: token,
                },
            });
            setRecord(recordData);
            setOwner(ownerData);
            setLoading(false);
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    async function getUpdateRecordRequestDetails() {
        setLoading(true);
        try {
          const {
            data: {
              updateRecordRequest: updateRecordRequestData,
              surveys: surveyData
            },
          } = await axios.get(
            `${BASE_URL}/users/${userId}/updateRecordRequests/${updateRecordRequestId}`,
            {
              headers: {
                Authorization: token,
              },
            }
          );

          setUpdateRecordRequest(updateRecordRequestData);
          setSurvey(surveyData);
    
          setLoading(false);
        } catch (err) {
          setLoading(false);
          console.log(err);
          ShowErrorAlert(extractErrorMessage(err));
        }
      }

    useEffect(() => {
        getRequestSurveyReq();
        getUpdateRecordRequestDetails();
    }, []);

    return (
        <DashboardLayout>
            {role === "CS" ?
                <Record
                    record={record}
                    owner={owner}
                    role={role}
                    recordId={recordId}
                    updateRecordRequest={updateRecordRequest}
                    survey={survey}
                /> : null
            }

            <DashboardCard>
                <div className="flex justify-between align-center">
                    <h5>Sahanka GIS</h5>
                </div>
                <DashboardTable
                    headings={DUES_TABLE_HEADINGS}
                    dataKeys={DUES_TABLE_DATA_KEYS}
                    data={record && record.length > 0 ? [record].map((record) => {
                        record.type = 'Taxes';
                        record.phoneNumber = owner.phoneNumber;
                        record.actions = <BlueText style={{textDecorationLine: "underline"}}>SEND PAYMENT LINK SMS</BlueText>
                        return record;
                    }) : []}
                />
            </DashboardCard>
        </DashboardLayout>
    );
};

export default Dues;
